import React from "react";
import Button from "../../Elements/Button/Button.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Image from "../../Elements/Image/Image.tsx";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

export const Err404 = () => {
  const { getTextByKey } = useContent();
  return (
    <div className="page-not-found-container">
      <Image name="robot" ext="png" />
      <div className="title-num">404</div>
      <div className="title-text">{getTextByKey("page-404-title")}</div>
      <div className="content-text">{getTextByKey("page-404-text")}</div>
      <Button>
        <LinkToNewTab page="home">{getTextByKey("back-home")}</LinkToNewTab>
      </Button>
    </div>
  );
};
